function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

if (!customElements.get('direct-order')) {
  class DirectOrder extends HTMLElement {

    constructor() {
      super();
      this.i18n = this.querySelector('[data-i18n]');
      try {
        this.i18n = JSON.parse(this.i18n.innerText);
      } catch (err) {
        this.i18n = null;
      }
      this.configuration = this.querySelector('[data-configuration]');
      try {
        this.configuration = JSON.parse(this.configuration.innerText);
      } catch (err) {
        this.configuration = null;
      }
      this.addAllItemsBtn = this.querySelector('[data-add-all-items]');
      this.directOrderItems = this.querySelector('[data-direct-order-items]');
      this.textarea = this.querySelector('textarea');
      this.errorTemplate = document.importNode(this.querySelector('template.error').content, true);
      this.loaderTemplate = document.importNode(this.querySelector('template.loader').content, true);
      this.debouncedOnInput = debounce((event) => this.onTextareaInput(event), 300);
      this.textarea.addEventListener('input', this.debouncedOnInput.bind(this));
      this.debouncedOnAddToCart = debounce((event) => this.onAddToCart(event), 300);
      this.addEventListener('add-to-cart', this.debouncedOnAddToCart.bind(this));
      this.addAllItemsBtn.addEventListener('click', this.debouncedOnAddToCart.bind(this));
      this.addEventListener('price-fetched', this.handlePricesFetched.bind(this));
    }

    onTextareaInput(event) {
      if (event.target.value !== '') {
        this.inputLines = event.target.value.split('\n').map((line, i) => {
          if (!line.includes('\t') && !line.includes(', ') && !line.includes(',')) {
            return this.i18n['header.direct_order.spacing_hint'];
          } else {
            line = line.replace('\t', '###');
            line = line.replace(', ', '###');
            line = line.replace(',', '###');
            const sku = line.split('###')[0];
            const quantity = parseFloat(line.split('###')[1]);
            return {
              sku: sku,
              product: null,
              quantity: !isNaN(quantity) && typeof quantity === 'number' ? quantity : 1
            }
          }
        });
      } else {
        this.inputLines = [];
        this.emptyAddToCartError();
        this.emptyLineItems();
      }
      if (this.inputLines.length) {
        this.emptyAddToCartError();
        this.emptyLineItems();
        this.setupLoader();
        this.fetchSKUS(this.inputLines.filter(line => typeof line === 'object').map(line => line.sku));
      }
    }

    disableAddAllToCartBtn() {
      this.addAllItemsBtn.setAttribute('disabled', '');
    }

    enableAddAllToCartBtn() {
      this.addAllItemsBtn.removeAttribute('disabled');
    }

    handlePricesFetched() {
      if (this.querySelectorAll('[data-add-single-item][disabled]').length === 0) {
        this.enableAddAllToCartBtn();
      }
    }

    emptyLineItems() {
      while(this.directOrderItems.firstChild) this.directOrderItems.removeChild(this.directOrderItems.firstChild);
      this.addAllItemsBtn.setAttribute('hidden', '');
      this.addAllItemsBtn.removeAttribute('data-loading');
      this.addAllItemsBtn.removeAttribute('data-success');
    }

    setupLoader() {
      this.directOrderItems.insertAdjacentHTML('beforeend', this.loaderTemplate.querySelector('li').outerHTML);
    }

    fetchSKUS(skus) {
      skus = skus.map(sku => `variants.sku:${sku}`);
      const url = new URL(`${window.location.origin}/search`);
      url.search = new URLSearchParams({ q: skus.join(' OR '), type: "product", view: `direct-order-sku-products` }).toString();
      fetch(url).then(r => r.json()).then(r => this.parseResults(r));
    }

    parseResults(r) {
      r.results.forEach(result => {
        const appendIndex = this.inputLines.findIndex(line => line && line.sku && (line.sku === result.sku));
        const correspondingInputLine = this.inputLines[appendIndex];
        if (correspondingInputLine) {
          const directOrderItemHtml = new DOMParser().parseFromString(result.productHtml, 'text/html').querySelector('direct-order-item');
          directOrderItemHtml.querySelector('[data-quantity]').value = correspondingInputLine.quantity;
          directOrderItemHtml.querySelector('[data-quantity]').setAttribute('value', correspondingInputLine.quantity);
          this.inputLines[appendIndex].product = directOrderItemHtml.outerHTML;
          this.inputLines[appendIndex].indirect_distribution = result.indirect_distribution;
        }
      });
      this.inputLines.forEach((line, index) => {
        if (typeof line === 'object' && !line.product) {
          this.inputLines[index] = this.i18n['header.direct_order.not_found_product_hint'];
        }
      })
      this.renderLineItems();
    }

    renderLineItems() {
      this.emptyLineItems();
      this.disableAddAllToCartBtn();
      this.inputLines.forEach((line, i) => {
        const lineNumber = i + 1;
        if (typeof line === 'object') {
          this.directOrderItems.insertAdjacentHTML('beforeend', `<li class="direct-order__item">${line.product}</li>`);
        } else {
          this.directOrderItems.insertAdjacentHTML('beforeend', this.errorTemplate.querySelector('li').outerHTML.replace('#no#', lineNumber).replace('#reason#', line));
        }
      });
      this.addAllItemsBtn.removeAttribute('hidden');
      if (this.configuration.customerLoggedIn == false) {
        this.enableAddAllToCartBtn();
      }
    }

    onAddToCart(event) {
      if (this.configuration.customerLoggedIn == false) {
        window.location.href = '/account/login';
        return;
      }
      const btn = event.target;
      let items;
      btn.setAttribute('data-loading', '');
      if (btn.dataset.addSingleItem != undefined) {
        btn.closest('direct-order-item').setAttribute('disabled', '');
        items = Array.from(btn.closest('direct-order-item').querySelectorAll('[data-variant-id]')).map(input => {
          const elProductPrice = input.closest('direct-order-item').querySelector('product-price');
          const productPrice = elProductPrice.getAttribute('data-price');
          const productFullPrice = elProductPrice.getAttribute('data-full-price');
          const productDisc = elProductPrice.getAttribute('data-disc');
          const productDiscpct = elProductPrice.getAttribute('data-discpct');
          return {
            id: parseFloat(input.value),
            quantity: parseFloat(input.closest('direct-order-item').querySelector('[data-quantity]').value),
            properties: {
              _price: parseFloat(productPrice) + '',
              _bego_price: parseFloat(productPrice) + '',
              _fullprice: parseFloat(productFullPrice) + '',
              _disc: parseFloat(productDisc) + '',
              _discpct: parseFloat(productDiscpct) + '',
            }
          }
        });
      } else if (btn.dataset.addAllItems != undefined) {
        this.querySelectorAll('direct-order-item').forEach(el => el.setAttribute('disabled', ''));
        items = Array.from(this.querySelectorAll('[data-variant-id]')).map(input => {
          const elProductPrice = input.closest('direct-order-item').querySelector('product-price');
          const productPrice = elProductPrice.getAttribute('data-price');
          const productFullPrice = elProductPrice.getAttribute('data-full-price');
          const productDisc = elProductPrice.getAttribute('data-disc');
          const productDiscpct = elProductPrice.getAttribute('data-discpct');
          return {
            id: parseFloat(input.value),
            quantity: parseFloat(input.closest('direct-order-item').querySelector('[data-quantity]').value),
            properties: {
              _price: parseFloat(productPrice) + '',
              _bego_price: parseFloat(productPrice) + '',
              _fullprice: parseFloat(productFullPrice) + '',
              _disc: parseFloat(productDisc) + '',
              _discpct: parseFloat(productDiscpct) + '',
            }
          }
        });
      }
      fetch('/cart/add.js', {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
      }).then(r => {
        return r.json().then(json => ({ status: r.status, response: json }));
      }).then(({ status, response }) => {
        if (status === 200) {
          btn.removeAttribute('data-loading');
          btn.setAttribute('data-success', '');
          let maxQuantity = 0;
          items.forEach(item => maxQuantity = maxQuantity + item.quantity);
          document.documentElement.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: {
              quantity: maxQuantity
            }
          }));
          if (btn.dataset.addSingleItem != undefined) {
            btn.closest('direct-order-item').removeAttribute('disabled');
          } else if (btn.dataset.addAllItems != undefined) {
            this.querySelectorAll('direct-order-item').forEach(el => el.removeAttribute('disabled', ''));
            this.querySelectorAll('direct-order-item').forEach(el => el.querySelector('[data-add-single-item]').setAttribute('data-success', ''));
          }
        } else if (status === 422) {
          btn.removeAttribute('data-loading');
          this.addToCartError(response.description);
          if (btn.dataset.addSingleItem != undefined) {
            btn.closest('direct-order-item').removeAttribute('disabled');
          } else if (btn.dataset.addAllItems != undefined) {
            this.querySelectorAll('direct-order-item').forEach(el => el.removeAttribute('disabled', ''));
          }
        }
      }).catch(err => {
        console.log(err);
      });
    }

    addToCartError(msg) {
      this.querySelector('[data-direct-order-error]').innerHTML = msg;
    }

    emptyAddToCartError() {
      this.querySelector('[data-direct-order-error]').innerHTML = '';
    }

  }

  customElements.define('direct-order', DirectOrder);

}

if (!customElements.get('direct-order-item')) {
  class DirectOrderItem extends HTMLElement {

    constructor() {
      super();
      this.addtoCartBtn = this.querySelector('[data-add-single-item]');
      if (this.addtoCartBtn) {
        this.addtoCartBtn.addEventListener('click', this.handleAddToCart.bind(this));
      }
      this.addToCartEvent = new Event('add-to-cart', { bubbles: true });
      this.addEventListener('price-fetched', this.handlePriceFetched.bind(this));
    }

    handleAddToCart() {
      this.addtoCartBtn.dispatchEvent(this.addToCartEvent);
    }

    handlePriceFetched() {
      this.addtoCartBtn.removeAttribute('disabled');
    }

  }

  customElements.define('direct-order-item', DirectOrderItem);

}


if (!customElements.get('quantity-input')) {
  class QuantityInput extends HTMLElement {

    constructor() {
      super();
      this.input = this.querySelector('input');
      this.changeEvent = new Event('change', { bubbles: true })

      this.querySelectorAll('button').forEach(
        (button) => button.addEventListener('click', this.onButtonClick.bind(this))
      );
    }

    onButtonClick(event) {
      event.preventDefault();
      const previousValue = this.input.value;

      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
      if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
    }

  }

  customElements.define('quantity-input', QuantityInput);

}